import modals from './modals';

export default {
  namespaced: true,
  modules: {
    modals
  },
};
